import { EvoMfeApp } from '@access-evo/evo-api';
import { EvoIframeMfesProvider } from '@access-evo/mfe-react-host';

// Test credentials for sandbox environment
const APPLICATION_ID = 'd1a45014-f485-4817-8c02-5243395572fd';
const APPLICATION_SUBSCRIPTION_ID = 'f0031bc3-e1c8-4198-8bd6-52aed519d564';

export default function CardPaymentsPage() {
  return (
    <div className="flex-1 space-y-6 p-4 md:p-6 pt-6">
      {/* Header */}
      <div className="space-y-2">
        <h2 className="text-3xl font-bold tracking-tight">Card Payments</h2>
        <p className="text-muted-foreground">
          View and manage credit and debit card transactions
        </p>
      </div>

      {/* Transactions List Component */}
      <div className="border rounded-lg bg-card">
        <EvoIframeMfesProvider>
          <EvoMfeApp
              name="pay-group-payments-component-orchestrator"
              version="x.x.x"
              parameters={{
                componentName: 'transactions-list',
                componentVersion: 'x.x.x',
                applicationId: APPLICATION_ID,
                applicationSubscriptionId: APPLICATION_SUBSCRIPTION_ID,
              }}
            />
        </EvoIframeMfesProvider>
      </div>
    </div>
  );
}
